export default "__VITE_ASSET__ZiITHRjc__"